import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { PASSWORD_CHANGE } from '../../../../constants/apiRoutes';

/**
 * changePassword.
 * @returns {Promise} - A promise that resolves with change Password or rejects with an error.
 * @param props
 */
export const changePassword = async ({
  moduleName,
  isServiceWorker,
  listController,
  data,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${PASSWORD_CHANGE}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

export default changePassword;
